import { motion } from 'framer-motion';
import { featuredProjects } from '../../data/projectsData';
import MotionReveal from '../ui/MotionReveal';
import { cardHover, ease } from '../../motion/variants';

const FeaturedBento = () => {
  if (!featuredProjects.length) return null;

  const [hero, ...rest] = featuredProjects;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-5 mb-10 sm:mb-12">
      <MotionReveal className="lg:col-span-7">
        <motion.a
          href={hero.liveDemo}
          target="_blank"
          rel="noopener noreferrer"
          initial="rest"
          whileHover="hover"
          variants={cardHover}
          transition={{ duration: 0.28, ease }}
          className="ant-card ant-ring ant-glass group block rounded-2xl border border-white/[0.08] bg-white/[0.02] overflow-hidden h-full cursor-pointer"
        >
          <div className="project-frame m-4 mb-0 aspect-[16/10]">
            <img
              src={hero.coverimg}
              alt={hero.name}
              loading="lazy"
              width={800}
              height={500}
              className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300"
            />
          </div>
          <div className="p-6 lg:p-8">
            <p className="font-mono text-[10px] tracking-widest text-ant-gold/70 uppercase mb-3">
              Featured · {hero.category}
            </p>
            <h3 className="text-2xl lg:text-3xl font-semibold text-white mb-3 group-hover:text-ant-gold transition-colors duration-200">
              {hero.name}
            </h3>
            <p className="text-sm text-white/45 leading-relaxed mb-6 line-clamp-2">{hero.description}</p>
            <div className="flex flex-wrap gap-2 mb-6">
              {hero.metrics.map((metric) => (
                <span
                  key={metric.label}
                  className="px-3 py-1.5 rounded-full border border-ant-green/20 bg-ant-green/10 font-mono text-xs text-ant-green"
                >
                  {metric.value} {metric.label}
                </span>
              ))}
            </div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-white/70 group-hover:text-white transition-colors">
              View live project
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </span>
          </div>
        </motion.a>
      </MotionReveal>

      <div className="lg:col-span-5 grid gap-4 lg:gap-5">
        {rest.map((project, index) => (
          <MotionReveal key={project.id} delay={(index + 1) * 50}>
            <motion.a
              href={project.liveDemo}
              target="_blank"
              rel="noopener noreferrer"
              initial="rest"
              whileHover="hover"
              variants={cardHover}
              transition={{ duration: 0.28, ease }}
              className="ant-card ant-ring ant-glass group flex gap-4 rounded-2xl border border-white/[0.08] bg-white/[0.02] p-4 h-full cursor-pointer"
            >
              <div className="project-frame w-28 sm:w-32 shrink-0 aspect-square">
                <img
                  src={project.coverimg}
                  alt={project.name}
                  loading="lazy"
                  width={128}
                  height={128}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex flex-col justify-center">
                <p className="font-mono text-[10px] text-ant-gold/60 mb-1">{project.category}</p>
                <h3 className="text-base font-semibold text-white truncate group-hover:text-ant-gold transition-colors duration-200">
                  {project.name}
                </h3>
                <p className="text-xs text-white/40 mt-1 line-clamp-2">{project.results}</p>
              </div>
            </motion.a>
          </MotionReveal>
        ))}
      </div>
    </div>
  );
};

export default FeaturedBento;